import { MIDINNING_AD_ENDED, MIDINNING_AD_STARTED } from '../actions/midInningAdEndedAction';

const MIDINNING_AD_PLAYED = 'MIDINNING_AD_PLAYED';

const updateCommercialBreak = (state = { adPlayed: 'none', adEnded: false }, action) => {
    const { type = null, datasource, data } = action;
    const gameInningStates = {};

    if (type === 'dataEngine_update_response' && datasource === 'gumbo') {
        const { gameData, gamePk, liveData } = data || {};

        const pk = gamePk;
        const status = gameData?.status?.abstractGameState || 'Preview';
        const inningState = liveData?.linescore?.inningState || 'Top';
        const currentInning = liveData?.linescore?.currentInning;
        const isEndOrMid = inningState === 'Middle' || inningState === 'End';
        let isCommercialBreak = false;

        // Game hasn't started or is over, stop advertising
        if (status === 'Live' && isEndOrMid) {
            if (!gameInningStates[pk] || (gameInningStates[pk] && gameInningStates[pk] !== inningState)) {
                isCommercialBreak = true;
            }
        }
        const transitionToBreak = isCommercialBreak && inningState !== gameInningStates[pk];
        const transitionFromBreak = !isCommercialBreak && !!(!gameInningStates[pk] || inningState !== gameInningStates[pk]);
        gameInningStates[pk] = inningState;

        const newData = {
            ...state,
            inningState,
            isCommercialBreak,
            transitionToBreak,
            transitionFromBreak,
            currentInning
        };

        return newData;
    } else if (type === 'dataEngine_update_response' && datasource === 'productConfig') {
        const {
            midInningAdConfig
        } = data;

        return {
            ...state,
            midInningAdConfig
        };
    } else if (type === MIDINNING_AD_PLAYED) {
        return {
            ...state,
            adPlayed: action.adPlayed
        };
    } else if (type === MIDINNING_AD_ENDED) {
        return {
            ...state,
            adEnded: action.adEnded
        };
    } else if (type === MIDINNING_AD_STARTED) {
        return {
            ...state,
            adStarted: action.adStarted
        };
    }

    return state;
};

export default updateCommercialBreak;
